module.exports = __webpack_public_path__ + "static/media/b5-white-english.47299783.png";